import { render, staticRenderFns } from "./ReportModal.vue?vue&type=template&id=64b68ad2&"
import script from "./ReportModal.vue?vue&type=script&lang=ts&"
export * from "./ReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReportModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports